// extracted by mini-css-extract-plugin
export default {"typing_wrapper":"Animation_typing_wrapper__f4WEH","typing_text":"Animation_typing_text__BMIx1","dot_flashing":"Animation_dot_flashing__FTjsZ"};